import { useEffect, useRef, useState } from "react";
import {
  useCheckoutLinesAddMutation,
  useCheckoutLinesUpdateMutation,
} from "../../../saleor/api";

export const useFastCheckoutLineSync = ({
  isLoggedIn,
  checkoutId,
  selectedVariantId,
  channel,
  quantity,
  checkoutLoading,
  checkoutData,
  checkoutRefetch,
}) => {
  const [syncingFastLine, setSyncingFastLine] = useState(false);
  const [fastCheckoutApplied, setFastCheckoutApplied] = useState(false);
  const [checkoutLinesAddMutation] = useCheckoutLinesAddMutation();
  const [checkoutLinesUpdateMutation] = useCheckoutLinesUpdateMutation();
  const syncedFastVariantKey = useRef("");

  useEffect(() => {
    if (
      !isLoggedIn ||
      !checkoutId ||
      !selectedVariantId ||
      !channel ||
      fastCheckoutApplied ||
      syncingFastLine ||
      checkoutLoading
    ) {
      return;
    }

    const syncKey = `${checkoutId}-${selectedVariantId}-${quantity}`;
    if (syncedFastVariantKey.current === syncKey) return;

    const checkoutLines = checkoutData?.checkout?.lines || [];
    const currentLine = checkoutLines.find(
      (line) => line?.variant?.id === selectedVariantId,
    );

    setSyncingFastLine(true);

    const onCompleted = () => {
      syncedFastVariantKey.current = syncKey;
      setFastCheckoutApplied(true);
      setSyncingFastLine(false);
      checkoutRefetch?.();
    };

    const onError = () => {
      setSyncingFastLine(false);
    };

    if (currentLine) {
      checkoutLinesUpdateMutation({
        variables: {
          id: checkoutId,
          lines: [
            {
              lineId: currentLine.id,
              quantity: currentLine.quantity + quantity,
            },
          ],
        },
        onCompleted,
        onError,
      });
      return;
    }

    checkoutLinesAddMutation({
      variables: {
        id: checkoutId,
        lines: [{ variantId: selectedVariantId, quantity }],
      },
      onCompleted,
      onError,
    });
  }, [
    isLoggedIn,
    checkoutId,
    selectedVariantId,
    channel,
    quantity,
    checkoutLoading,
    checkoutData,
    checkoutRefetch,
    fastCheckoutApplied,
    syncingFastLine,
    checkoutLinesAddMutation,
    checkoutLinesUpdateMutation,
  ]);

  useEffect(() => {
    if (fastCheckoutApplied || !isLoggedIn || !selectedVariantId) return;

    const hasFastVariantInCheckout = (checkoutData?.checkout?.lines || []).some(
      (line) => line?.variant?.id === selectedVariantId,
    );

    if (hasFastVariantInCheckout) {
      setFastCheckoutApplied(true);
    }
  }, [fastCheckoutApplied, isLoggedIn, selectedVariantId, checkoutData]);

  return { syncingFastLine, fastCheckoutApplied };
};
